(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-crewnecks-sweaters-comparison"] && !Shopify.designMode) return;
  try {
    
(function(){
  // FIXED: this section originally watched `.rba-ptp__tier-card.is-selected[data-tier]`,
  // which was the t-shirt product's OLD tier-picker markup. The sweater/crewneck page
  // actually renders tiers through rba-tee-variant-picker.liquid, whose markup is
  // completely different (.rba-tier-shell / .rba-tier-card / native radio inputs, no
  // .rba-ptp or data-tier anywhere). None of the old selectors ever matched, so this
  // section always fell back to the hardcoded 'Premium' default and never updated when a
  // customer clicked a tier. This version reads the real picker's checked radio input.
  function currentTier(){
    var checked = document.querySelector('.rba-tier-list input:checked');
    var shell = checked && checked.closest('.rba-tier-shell');
    var nameEl = shell && shell.querySelector('.rba-tier-card__copy strong');
    var text = (nameEl && nameEl.textContent || '').trim().toLowerCase();
    if (text) return text;

    var picker = document.querySelector('.rba-tee-picker[data-rba-default-tier]');
    var fallback = picker && picker.dataset.rbaDefaultTier;
    return (fallback || 'essential').toLowerCase();
  }

  function show(tier){
    document.querySelectorAll('[data-rba-crew-compare-tier]').forEach(function(card){
      card.classList.toggle('is-active', card.dataset.rbaCrewCompareTier === tier);
    });
  }

  function sync(){
    show(currentTier());
  }

  // Tier selection in rba-tee-variant-picker.liquid is a native radio input, and every
  // path that changes it (user click, or the picker's own colour-reset logic) dispatches
  // a real 'change' event — so listening for 'change' on the tier fieldset covers all of
  // them, not just direct clicks.
  document.addEventListener('change', function(event){
    var input = event.target;
    if (input && input.closest && input.closest('.rba-tier-list')) {
      sync();
    }
  }, true);

  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-crewnecks-sweaters-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  // FIXED: this watched `.rba-ptp__tier-card.is-selected[data-tier]`, the t-shirt page's
  // OLD tier-picker markup. The sweater/crewneck page renders tiers through
  // rba-tee-variant-picker.liquid instead, whose markup is completely different
  // (.rba-tier-shell / .rba-tier-card / native radio inputs, no .rba-ptp or data-tier
  // anywhere) — so none of the old selectors ever matched, and this section always fell
  // back to the hardcoded 'Premium' default no matter what the customer clicked. Same fix
  // as RBA Crewneck Comparison: read the real picker's checked radio input directly.
  function currentTier(){
    var checked = document.querySelector('.rba-tier-list input:checked');
    var shell = checked && checked.closest('.rba-tier-shell');
    var nameEl = shell && shell.querySelector('.rba-tier-card__copy strong');
    var text = (nameEl && nameEl.textContent || '').trim().toLowerCase();
    if (text) return text;

    var picker = document.querySelector('.rba-tee-picker[data-rba-default-tier]');
    var fallback = picker && picker.dataset.rbaDefaultTier;
    return (fallback || 'essential').toLowerCase();
  }

  function show(tier){
    document.querySelectorAll('[data-rba-crew-story-tier]').forEach(function(panel){
      panel.hidden = panel.dataset.rbaCrewStoryTier !== tier;
    });
  }

  function sync(){
    show(currentTier());
  }

  // Tier selection is a native radio input in rba-tee-variant-picker.liquid, and every
  // path that changes it dispatches a real 'change' event — user clicks, and the picker's
  // own colour-reset logic alike — so listening for 'change' on the tier fieldset covers
  // all of them, not just direct clicks.
  document.addEventListener('change', function(event){
    var input = event.target;
    if (input && input.closest && input.closest('.rba-tier-list')) {
      sync();
    }
  }, true);

  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-premium-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-rba-premium-collection]');
    if (!section) return;

    const sortSelect = section.querySelector('[data-rba-premium-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    const template = section.querySelector('template[id^="RbaEditorialTile-"]');
    if (!template) return;

    const insertEditorialTile = () => {
      const grid = document.querySelector('.product-grid.product-grid--grid');
      if (!grid || grid.querySelector('[data-rba-editorial-tile]')) return;
      const cards = Array.from(grid.children).filter((item) => !item.hasAttribute('data-rba-editorial-tile'));
      if (cards.length < 5) return;
      const tile = template.content.cloneNode(true);
      cards[4].after(tile);
    };

    insertEditorialTile();
    const observer = new MutationObserver(() => insertEditorialTile());
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-sweatshirt-guide"] && !Shopify.designMode) return;
  try {
    

(function(){

  var ROOT = '.rba-sweatshirt-guide';

  var PICKER_INPUTS =
    '.rba-sweatshirt-picker .rba-option--tiers input,' +
    '.rba-crewneck-picker .rba-option--tiers input,' +
    '.rba-tee-picker .rba-option--tiers input';


  var data = {

    essential: {

      model:
        'Gildan 18000 Heavy Blend',

      lead:
        'A dependable everyday crewneck with soft brushed fleece and a comfortable classic fit.',

      feel:
        'Soft. Cozy. Everyday.',

      feelLead:
        'Warm brushed fleece and a classic shape make this an easy sweatshirt for everyday wear.',

      note:
        'A reliable everyday sweatshirt with familiar comfort, soft fleece and excellent value.',

      specs: [
        [
          '8.0 oz./yd²',
          'Comfortable midweight fleece'
        ],
        [
          '50/50 cotton/poly',
          'Soft and durable blend'
        ],
        [
          'Classic fit',
          'Loose, familiar shape'
        ],
        [
          'Brushed interior',
          'Warm cozy softness'
        ]
      ],

      features: [
        [
          '≈',
          'BRUSHED FLEECE',
          'Soft and comfortable inside'
        ],
        [
          'T',
          'CLASSIC FIT',
          'An easy everyday shape'
        ],
        [
          '✦',
          'GREAT VALUE',
          'Dependable and versatile'
        ]
      ]

    },


    premium: {

      model:
        'Gildan SF000 Softstyle',

      lead:
        'A softer premium crewneck made with ring-spun cotton rich fleece for an upgraded everyday feel.',

      feel:
        'Soft. Smooth. Refined.',

      feelLead:
        'A premium midweight fleece with a soft cotton-rich feel, warm interior and comfortable classic shape.',

      note:
        'Our premium choice for a softer hand, elevated fabric and comfortable everyday wear.',

      specs: [
        [
          '8.4 oz./yd²',
          'Premium midweight fleece'
        ],
        [
          '80/20 cotton/poly',
          'Ring-spun cotton rich blend'
        ],
        [
          'Classic fit',
          'Comfortable loose shape'
        ],
        [
          'Softstyle fleece',
          'Smooth premium feel'
        ]
      ],

      features: [
        [
          '≈',
          'SOFTSTYLE FLEECE',
          'Soft ring-spun cotton rich feel'
        ],
        [
          'T',
          'CLASSIC FIT',
          'Comfortable everyday shape'
        ],
        [
          '✦',
          'BEST BALANCE',
          'Our premium everyday choice'
        ]
      ]

    },


    elevated: {

      model:
        'Comfort Colors 1566',

      lead:
        'A substantial garment-dyed crewneck with heavyweight fleece, a relaxed fit and signature lived-in character.',

      feel:
        'Heavy. Relaxed. Lived in.',

      feelLead:
        'Soft-washed heavyweight fleece with a relaxed silhouette and unmistakable Comfort Colors garment-dyed character.',

      note:
        'Garment-dyed colours are intentionally designed with soft vintage character and natural colour variation.',

      specs: [
        [
          '9.5 oz./yd²',
          'Substantial heavyweight fleece'
        ],
        [
          '80/20 cotton/poly',
          'Ring-spun construction'
        ],
        [
          'Relaxed fit',
          'Easy laid-back shape'
        ],
        [
          'Garment dyed',
          'Rich lived-in character'
        ]
      ],

      features: [
        [
          '≈',
          'HEAVYWEIGHT',
          '9.5 oz substantial fleece'
        ],
        [
          'T',
          'RELAXED FIT',
          'Easy lived-in shape'
        ],
        [
          '✦',
          'GARMENT DYED',
          'Signature vintage character'
        ]
      ]

    }

  };


  function inputs(){

    return Array.from(
      document.querySelectorAll(
        PICKER_INPUTS
      )
    );

  }


  function tierOf(input){

    if(!input){
      return '';
    }

    var card =
      input.closest('.rba-tier-card');

    var name =
      card &&
      card.querySelector(
        '.rba-tier-card__copy strong'
      );

    return (
      name &&
      name.textContent ||
      ''
    )
    .trim()
    .toLowerCase();

  }


  function current(){

    var input =
      inputs().find(
        function(item){
          return item.checked;
        }
      );

    return tierOf(input) || 'essential';

  }


  function renderRoot(
    root,
    tier
  ){

    var d =
      data[tier] ||
      data.essential;

    var badge =
      root.querySelector(
        '[data-story-badge]'
      );

    var model =
      root.querySelector(
        '[data-story-model]'
      );

    var lead =
      root.querySelector(
        '[data-story-lead]'
      );

    var feel =
      root.querySelector(
        '[data-story-feel]'
      );

    var feelLead =
      root.querySelector(
        '[data-story-feel-lead]'
      );

    var note =
      root.querySelector(
        '[data-story-note]'
      );

    var specs =
      root.querySelector(
        '[data-story-specs]'
      );

    var features =
      root.querySelector(
        '[data-story-features]'
      );


    if(badge){
      badge.textContent =
        tier.toUpperCase();
    }


    if(model){
      model.textContent =
        d.model;
    }


    if(lead){
      lead.textContent =
        d.lead;
    }


    if(feel){
      feel.textContent =
        d.feel;
    }


    if(feelLead){
      feelLead.textContent =
        d.feelLead;
    }


    if(note){
      note.textContent =
        d.note;
    }


    if(specs){

      specs.innerHTML =
        d.specs
        .map(function(x){

          return (
            '<div class="rba-sweatshirt-guide__spec">' +
              '<strong>' +
                x[0] +
              '</strong>' +
              '<span>' +
                x[1] +
              '</span>' +
            '</div>'
          );

        })
        .join('');

    }


    if(features){

      features.innerHTML =
        d.features
        .map(function(x){

          return (
            '<div class="rba-sweatshirt-guide__feature">' +
              '<span>' +
                x[0] +
              '</span>' +
              '<strong>' +
                x[1] +
              '</strong>' +
              '<small>' +
                x[2] +
              '</small>' +
            '</div>'
          );

        })
        .join('');

    }


    root
    .querySelectorAll(
      '[data-guide-hero]'
    )
    .forEach(
      function(hero){

        hero.hidden =
          hero.dataset.guideHero !== tier;

      }
    );


    root
    .querySelectorAll(
      '[data-guide-tier]'
    )
    .forEach(
      function(card){

        var active =
          card.dataset.guideTier === tier;

        card.classList.toggle(
          'is-active',
          active
        );

        card.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );

      }
    );

  }


  function renderAll(tier){

    var activeTier =
      tier ||
      current();

    document
    .querySelectorAll(ROOT)
    .forEach(
      function(root){

        renderRoot(
          root,
          activeTier
        );

      }
    );

  }


  function select(tier){

    var target =
      inputs().find(
        function(input){

          return (
            tierOf(input) === tier
          );

        }
      );


    if(!target){

      renderAll(tier);

      return;

    }


    if(!target.checked){

      target.click();

    }


    renderAll(tier);

  }


  document.addEventListener(
    'click',
    function(e){

      if(
        !e.target ||
        !e.target.closest
      ){
        return;
      }

      var card =
        e.target.closest(
          ROOT +
          ' [data-guide-tier]'
        );

      if(!card){
        return;
      }

      select(
        card.dataset.guideTier
      );

    }
  );


  document.addEventListener(
    'change',
    function(e){

      if(
        e.target &&
        e.target.matches &&
        e.target.matches(
          PICKER_INPUTS
        )
      ){

        renderAll(
          tierOf(e.target) ||
          current()
        );

      }

    }
  );


  document.addEventListener(
    'shopify:product:select',
    function(e){

      Promise.resolve(
        e &&
        e.promise
      )
      .then(
        function(){

          renderAll();

        }
      );

    }
  );


  document.addEventListener(
    'shopify:section:load',
    function(){

      renderAll();

    }
  );


  if(
    document.readyState ===
    'loading'
  ){

    document.addEventListener(
      'DOMContentLoaded',
      function(){

        renderAll();

      },
      {
        once:true
      }
    );

  }else{

    renderAll();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-tee-comparison"] && !Shopify.designMode) return;
  try {
    
(function(){
  function tier(){var c=document.querySelector('.rba-tee-picker .rba-option--tiers input:checked');var card=c&&c.closest('.rba-tier-card');var s=card&&card.querySelector('.rba-tier-card__copy strong');return(s&&s.textContent||'essential').trim().toLowerCase();}
  function sync(){var t=tier();document.querySelectorAll('[data-rba-compare-tier]').forEach(function(card){card.classList.toggle('is-active',card.dataset.rbaCompareTier===t);});}
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('.rba-option--tiers'))sync();});document.addEventListener('shopify:product:select',sync);document.addEventListener('shopify:section:load',sync);if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sync,{once:true});}else{sync();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-tee-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  var data={
    essential:{model:'Gildan 64000CVC Softstyle',lead:'A dependable everyday tee with a soft hand and an easy classic fit.',feel:'Soft. Easy. Everyday.',feelLead:'Lightweight and versatile, made for dependable comfort and everyday wear.',note:'A reliable everyday choice with a soft, easy-wearing feel.',specs:[['4.5 oz./yd²','Lightweight feel'],['60/40 CVC blend','Soft everyday comfort'],['Classic fit','Easy, familiar shape'],['Tubular body','Simple construction']],features:[['≈','SOFT CVC BLEND','Comfort from the first wear'],['T','CLASSIC FIT','An easy everyday shape'],['✦','GREAT VALUE','Dependable and versatile']]},
    premium:{model:'Next Level 6210',lead:'The perfect everyday tee. Super soft, lightweight and made to last.',feel:'Soft. Comfortable. Built to last.',feelLead:'A premium 60/40 CVC blend that feels soft from the first wear and stays comfortable all day.',note:'Colours have a soft CVC character; appearance varies by colour.',specs:[['4.3 oz./yd²','Soft, lightweight feel'],['60/40 CVC blend','Combed ring-spun fabric'],['Regular fit','Clean retail shape'],['Side seams','Structured construction']],features:[['≈','SOFT & LIGHT','4.3 oz for all-day comfort'],['T','REGULAR FIT','Clean, modern everyday shape'],['✦','BEST BALANCE','Our everyday sweet spot']]},
    elevated:{model:'Comfort Colors 1717',lead:'A substantial garment-dyed tee with a relaxed fit and lived-in feel.',feel:'Relaxed. Substantial. Lived in.',feelLead:'A heavyweight ring-spun cotton tee with a relaxed silhouette and garment-dyed character.',note:'Garment-dyed colours are designed to have a washed, lived-in character.',specs:[['6.1 oz./yd²','Substantial heavyweight feel'],['100% ring-spun cotton','Soft-washed comfort'],['Relaxed fit','Easy, laid-back shape'],['Garment dyed','Rich lived-in character']],features:[['≈','HEAVYWEIGHT','6.1 oz substantial cotton'],['T','RELAXED FIT','Easy, lived-in shape'],['✦','PREMIUM FEEL','Garment-dyed character']]}
  };

  function tierOf(input){
    var card=input&&input.closest('.rba-tier-card');
    var name=card&&card.querySelector('.rba-tier-card__copy strong');
    return (name&&name.textContent||'').trim().toLowerCase();
  }

  function current(){
    var input=document.querySelector('.rba-tee-picker .rba-option--tiers input:checked');
    return tierOf(input)||'essential';
  }

  function renderRoot(root,tier){
    var d=data[tier]||data.essential;
    var badge=root.querySelector('[data-story-badge]');
    var model=root.querySelector('[data-story-model]');
    var lead=root.querySelector('[data-story-lead]');
    var feel=root.querySelector('[data-story-feel]');
    var feelLead=root.querySelector('[data-story-feel-lead]');
    var note=root.querySelector('[data-story-note]');
    var specs=root.querySelector('[data-story-specs]');
    var features=root.querySelector('[data-story-features]');

    if(badge) badge.textContent=tier.toUpperCase();
    if(model) model.textContent=d.model;
    if(lead) lead.textContent=d.lead;
    if(feel) feel.textContent=d.feel;
    if(feelLead) feelLead.textContent=d.feelLead;
    if(note) note.textContent=d.note;
    if(specs) specs.innerHTML=d.specs.map(function(x){return '<div class="rba-guide__spec"><strong>'+x[0]+'</strong><span>'+x[1]+'</span></div>';}).join('');
    if(features) features.innerHTML=d.features.map(function(x){return '<div class="rba-guide__feature"><span>'+x[0]+'</span><strong>'+x[1]+'</strong><small>'+x[2]+'</small></div>';}).join('');

    root.querySelectorAll('[data-guide-hero]').forEach(function(hero){
      hero.hidden=hero.dataset.guideHero!==tier;
    });

    root.querySelectorAll('[data-guide-tier]').forEach(function(card){
      var active=card.dataset.guideTier===tier;
      card.classList.toggle('is-active',active);
      card.setAttribute('aria-pressed',active?'true':'false');
    });
  }

  function renderAll(tier){
    var activeTier=tier||current();
    document.querySelectorAll('.rba-guide').forEach(function(root){
      renderRoot(root,activeTier);
    });
  }

  function select(tier){
    var inputs=Array.from(document.querySelectorAll('.rba-tee-picker .rba-option--tiers input'));
    var target=inputs.find(function(input){return tierOf(input)===tier;});
    if(!target){
      renderAll(tier);
      return;
    }
    if(!target.checked){
      target.click();
    }
    renderAll(tier);
  }

  document.addEventListener('click',function(e){
    var card=e.target.closest('.rba-guide [data-guide-tier]');
    if(!card)return;
    select(card.dataset.guideTier);
  });

  document.addEventListener('change',function(e){
    if(e.target&&e.target.closest&&e.target.closest('.rba-tee-picker .rba-option--tiers')){
      renderAll(tierOf(e.target)||current());
    }
  });

  document.addEventListener('shopify:product:select',function(e){
    Promise.resolve(e&&e.promise).then(function(){renderAll();});
  });

  document.addEventListener('shopify:section:load',function(){renderAll();});

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){renderAll();},{once:true});
  }else{
    renderAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rba-tee-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  function currentTier(){
    var checked=document.querySelector('.rba-tee-picker .rba-option--tiers input:checked');
    var label=checked&&checked.closest('.rba-tier-card');
    var strong=label&&label.querySelector('.rba-tier-card__copy strong');
    return (strong&&strong.textContent||'essential').trim().toLowerCase();
  }
  function sync(){
    var tier=currentTier();
    document.querySelectorAll('[data-rba-story-tier]').forEach(function(panel){panel.hidden=panel.dataset.rbaStoryTier!==tier;});
  }
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('.rba-option--tiers'))sync();});
  document.addEventListener('shopify:product:select',sync);
  document.addEventListener('shopify:section:load',sync);
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sync,{once:true});}else{sync();}
})();

  } catch(e) { console.error(e); }
})();
})();
